// src/client/navigation/AppNavigator.tsx
// Layout component nested inside ProtectedRoute + KycGuard. Renders the
// child route via <Outlet/> and overlays the floating NavBar.
import { Outlet } from 'react-router-dom';
import NavBar from '@client/components/NavBar';

export default function AppNavigator() {
  return (
    <>
      <Outlet />
      <NavBar />
    </>
  );
}
